import { render, staticRenderFns } from "./ProposalPoInfo.vue?vue&type=template&id=766705f2&scoped=true"
import script from "./ProposalPoInfo.vue?vue&type=script&lang=js"
export * from "./ProposalPoInfo.vue?vue&type=script&lang=js"
import style0 from "./ProposalPoInfo.vue?vue&type=style&index=0&id=766705f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766705f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766705f2')) {
      api.createRecord('766705f2', component.options)
    } else {
      api.reload('766705f2', component.options)
    }
    module.hot.accept("./ProposalPoInfo.vue?vue&type=template&id=766705f2&scoped=true", function () {
      api.rerender('766705f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/ProposalPoInfo.vue"
export default component.exports